import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Spin, message } from 'antd';


import RightImageComponent from './right_image_component'
import AuthFooterComponent from './footer_component'
import AuthenticationService from '../../service/authentication_service';
import AppService from '../../service/app_service';

let state = false;
let passwordStrength = document.getElementById("password-strength");
let lowUpperCase = document.querySelector(".low-upper-case i");
let number = document.querySelector(".one-number i");
let specialChar = document.querySelector(".one-special-char i");
let eightChar = document.querySelector(".eight-character i");
let strength = 0;

class SignupPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dashboard: props.dashboard,
            clientId: 'uauth_fc0114271c4e5f18',
            roleName: 'iam:SOMEONE',
            referredBy: AuthenticationService.getReferral() ? AuthenticationService.getReferral() : "none",
            loading: false,
            identityVerified: true,
            identificationType: 'nin'
        };
    }

    componentDidMount(){
        lowUpperCase = document.querySelector(".low-upper-case i");
        number = document.querySelector(".one-number i");
        number = document.querySelector(".one-number i");
        specialChar = document.querySelector(".one-special-char i");
        eightChar = document.querySelector(".eight-character i");
        passwordStrength = document.getElementById("password-strength");
    }


    logout = () => {
        AuthenticationService.clearLocalstorage();
    }
    handleChange = (e) => {
        

        if(e.target.name === "iAccept") {
            this.setState({
                [e.target.name]: e.target.checked
            });
        }else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }

        if(e.target.name === "password") {
            this.checkStrength(e.target.value);
        }
        
    }

    signUp = () => {
        if(parseInt(this.state.strengths) < 4) {
            message.error("Password strength is not strong");
        }else {
            this.setState({ loading: true });
            AppService.signUp(this.state).then(rec => {
                if (rec) {
                    if (rec.code !== "200") {
                        message.error(rec.message);
                        this.setState({ loading: false });
                    } else {
                        message.success("Successful")
                        this.props.history.push("/signin");
                    }
                } else {
                    message.error("Empty response")
                }
            })
        }
        
    }


    validateIdentification = () => {
        this.setState({ loading: true, identityVerified: false, data: null, otpSent: false });

        AppService.validateIdentification(this.state).then(rec => {
            if (rec) {
                if (rec.code !== "200") {
                    message.error(rec.message);
                    this.setState({ loading: false });
                } else {
                    message.success(rec.data.message);
                    this.setState({ loading: false, data: rec.data, identityVerified: true, otpSent: rec.data.otpSent });
                }
            } else {
                message.error("Empty response")
            }
        })
    }

    verifyOtp = () => {
        this.setState({ loading: true });
        let data = this.state;
        data.verifyPhoneNumber = true;

        AppService.validateIdentification(data).then(rec => {
            if (rec) {
                if (rec.code !== "200") {
                    message.error(rec.message);
                    this.setState({ loading: false });
                } else {
                    message.success("Successful")
                    this.setState({ loading: false, data: rec.data, identityVerified: true });
                }
            } else {
                message.error("Empty response")
            }
        })
    }


    toggle = () => {
        console.log("toggle")
        if(state){
            document.getElementById("password").setAttribute("type","password");
            state = false;
        }else{
            document.getElementById("password").setAttribute("type","text")
            state = true;
        }
    }
    
    myFunction = (show) => {
        console.log("myFunction")
        document.getElementById("eye").classList.toggle("fa-eye-slash");
    }
    
    checkStrength = (password) => {
        strength = 0;
    
        //If password contains both lower and uppercase characters
        if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
            strength += 1;
            lowUpperCase.classList.remove('fa-circle');
            lowUpperCase.classList.add('fa-check');
        } else {
            lowUpperCase.classList.add('fa-circle');
            lowUpperCase.classList.remove('fa-check');
        }
        //If it has numbers and characters
        if (password.match(/([0-9])/)) {
            strength += 1;
            number.classList.remove('fa-circle');
            number.classList.add('fa-check');
        } else {
            number.classList.add('fa-circle');
            number.classList.remove('fa-check');
        }
        //If it has one special character
        if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
            strength += 1;
            specialChar.classList.remove('fa-circle');
            specialChar.classList.add('fa-check');
        } else {
            specialChar.classList.add('fa-circle');
            specialChar.classList.remove('fa-check');
        }
        //If password is greater than 7
        if (password.length > 7) {
            strength += 1;
            eightChar.classList.remove('fa-circle');
            eightChar.classList.add('fa-check');
        } else {
            eightChar.classList.add('fa-circle');
            eightChar.classList.remove('fa-check');   
        }
    
        // If value is less than 2
        if (strength < 2) {
            passwordStrength.classList.remove('progress-bar-warning');
            passwordStrength.classList.remove('progress-bar-success');
            passwordStrength.classList.add('progress-bar-danger');
            passwordStrength.style = 'width: 10%';
        } else if (strength == 3) {
            passwordStrength.classList.remove('progress-bar-success');
            passwordStrength.classList.remove('progress-bar-danger');
            passwordStrength.classList.add('progress-bar-warning');
            passwordStrength.style = 'width: 60%';
        } else if (strength == 4) {
            passwordStrength.classList.remove('progress-bar-warning');
            passwordStrength.classList.remove('progress-bar-danger');
            passwordStrength.classList.add('progress-bar-success');
            passwordStrength.style = 'width: 100%';
        }
        this.setState({ strengths: strength });
    }

    render() {

        const { loading, referredBy, identityVerified, identificationType, data, otpSent, iAccept, strengths } = this.state;
        return (
            <div className="page-ath-wrap">
                <div className="page-ath-content">
                    <div className="page-ath-header"><a href="/" className="page-ath-logo"><img src="/assets/images/logo.png" srcSet="/assets/images/logo.png 2x" alt="logo" /></a></div>
                    <Spin spinning={loading}>
                        <div className="page-ath-form">
                            <h2 className="page-ath-heading">Sign up</h2>
                            <form onSubmit={e => e.preventDefault()}>
                                {/* {!otpSent && !data && <div>
                                    <div className="input-item input-with-label">
                                        <label htmlFor="nationality" className="input-item-label">Select Means Of ID</label>
                                        <select className="input-bordered" name="identificationType" id="identificationType" onChange={this.handleChange} >
                                            <option value="nin">NIN</option>
                                            <option value="bvn">BVN</option>
                                        </select>
                                    </div>
                                    {
                                        identificationType && <div className="input-item">
                                                <label htmlFor="nationality" className="input-item-label">Enter {identificationType} number</label>
                                                <input type="text" onChange={this.handleChange} placeholder={'Enter your '+ identificationType} name="number" className="input-bordered" />
                                            </div>
                                    }
                                    <button className="btn btn-primary btn-block" onClick={this.validateIdentification}>Validate ID</button>
                                </div>}

                                {data  && otpSent && !data.data && <div style={{marginTop: '10px'}}>
                                        <div className="input-item">
                                            <p>{data.message}</p>
                                        <label htmlFor="otp" className="input-item-label">OTP</label>
                                        <input type="text" onChange={this.handleChange} placeholder="OTP" name="otp" className="input-bordered" />
                                    </div>
                                    <button className="btn btn-primary btn-block" onClick={this.verifyOtp}>Verify OTP</button>
                                    </div>
                                } */}
                                {data && data.data && <div>
                                    <img src={data.data.image} style={{marginBottom: '10px', borderRadius: '50%', marginLeft: '10px', width: '200px', height: '200px'}} />
                                    <div className="input-item">
                                        <label htmlFor="firstName" className="input-item-label">Firstname</label>
                                        <input type="text" value={data.data.firstName} placeholder="Your First Name" name="firstName" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="lastName" className="input-item-label">Lastname</label>
                                        <input type="text" value={data.data.lastName} placeholder="Your Last Name" name="lastName" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="email" className="input-item-label">Email</label>
                                        <input type="text" value={data.data.email} placeholder="Your Email" name="emailAddress" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="Phone" className="input-item-label">Phone Number</label>
                                        <input type="text" value={data.data.phone} placeholder="Phone number" name="mobileNumber" className="input-bordered" />
                                    </div>
                                    
                                    <p>By Proceeding, you do confirm that the above information is correct.</p>
                                </div>}
                                {<div style={{marginTop: '10px'}}>
                                    
                                    <div className="input-item">
                                        <label htmlFor="firstName" className="input-item-label">Firstname</label>
                                        <input type="text" onChange={this.handleChange} placeholder="Your First Name" name="firstName" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="lastName" className="input-item-label">Lastname</label>
                                        <input type="text" onChange={this.handleChange} placeholder="Your Last Name" name="lastName" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="email" className="input-item-label">Email</label>
                                        <input type="text" onChange={this.handleChange} placeholder="Your Email" name="emailAddress" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="Phone" className="input-item-label">Phone Number</label>
                                        <input type="text" onChange={this.handleChange} placeholder="Phone number" name="mobileNumber" className="input-bordered" />
                                    </div>
                                    
                                    <div className="input-item">
                                        <label htmlFor="xsxa" className="input-item-label"> -----------   Fill Credentials ----------- </label>
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="nationality" className="input-item-label">Username</label>
                                        <input type="text" onChange={this.handleChange} placeholder="Username" name="username" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="nationality" className="input-item-label">Password</label>
                                    </div>
                                    <div className="input-item">
                                        <input type="password" onChange={this.handleChange} placeholder="Password" id="password" name="password" className="input-bordered" />
                                        <span className="show-pass" onClick={() => this.toggle()}>
                                            <i className="far fa-eye" id="eye" onClick={() => this.myFunction(this)}></i>
                                        </span>
                                        <div id="popover-password">
                                            <p><span id="result"></span></p>
                                            <div className="progress">
                                                <div id="password-strength" 
                                                    class="progress-bar" 
                                                    role="progressbar" 
                                                    aria-valuenow="40" 
                                                    aria-valuemin="0" 
                                                    aria-valuemax="100" 
                                                    style={{width:'0%'}}>
                                                </div>
                                            </div>
                                            <ul className="list-unstyled">
                                                <li className="">
                                                    <span className="low-upper-case">
                                                        <i className="fas fa-circle" aria-hidden="true"></i>
                                                        &nbsp;Lowercase &amp; Uppercase
                                                    </span>
                                                </li>
                                                <li className="">
                                                    <span className="one-number">
                                                        <i className="fas fa-circle" aria-hidden="true"></i>
                                                        &nbsp;Number (0-9)
                                                    </span> 
                                                </li>
                                                <li className="">
                                                    <span className="one-special-char">
                                                        <i className="fas fa-circle" aria-hidden="true"></i>
                                                        &nbsp;Special Character (!@#$%^&*)
                                                    </span>
                                                </li>
                                                <li className="">
                                                    <span className="eight-character">
                                                        <i className="fas fa-circle" aria-hidden="true"></i>
                                                        &nbsp;Atleast 8 Character
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="input-item">
                                        <div className="tacbox">
                                            <input id="iAccept" name="iAccept" type="checkbox" onChange={this.handleChange} />
                                            <label for="checkbox"> I agree to these <a href="https://unifiedorbit.com/xchange/attachments/files/Acceptable_Use_Policy.pdf" target="_blank">Terms and Conditions</a>.</label>
                                        </div>
                                    </div>
                                    {/* {referredBy !== "none" && false && <div className="input-item"><input type="text" disabled={referredBy !== "none"} value={this.state.referredBy} placeholder="Referral" className="input-bordered" /></div>} */}
                                </div>}
                                
                                
                                {/* <div className="input-item text-left"><input className="input-checkbox input-checkbox-md" id="term-condition" type="checkbox" /><label htmlFor="term-condition">I agree to TokenWiz’s <a href="regular-page.html">Privacy Policy</a> &amp; <a href="regular-page.html"> Terms.</a></label></div> */}

                                {/* {data && data.data && data.data.email && data.data.phone && data.data.phoneVerified &&   */}
                                {<button className="btn btn-primary btn-block" disabled={(!iAccept)} onClick={this.signUp}>Create Account</button>}
                                 {/* } */}
                                {/* {data && data.data && data.data.email && data.data.phone && !data.data.phoneVerified &&  <button className="btn btn-primary btn-block" onClick={this.validateIdentification}>Refresh Verification</button>} */}
                            </form>
                            {/* <div className="sap-text"><span>Or Sign Up With</span></div>
                            <ul className="row guttar-20px guttar-vr-20px">
                                <li className="col"><a href="#" className="btn btn-outline btn-dark btn-facebook btn-block"><em className="fab fa-facebook-f" /><span>Facebook</span></a></li>
                                <li className="col"><a href="#" className="btn btn-outline btn-dark btn-google btn-block"><em className="fab fa-google" /><span>Google</span></a></li>
                            </ul> */}
                            <div className="gaps-2x" />
                            <div className="gaps-2x" />
                            <div className="form-note">Already have an account ? <Link to="/signin"> <strong>Sign in instead</strong></Link></div>
                        </div>
                    </Spin>
                    <AuthFooterComponent />
                </div>
                
                {<RightImageComponent image={'/asset/images/user.png'} />}
            </div>
        );
    }
}

export default withRouter(SignupPage);
